/** Gujarat intra-state GST: GST prefix 24 or party state Gujarat → SGST+CGST, not IGST */
export function isGujaratBilling(billingData) {
  if (!billingData) return false;
  const gstNumber =
    billingData.splitGSTNumber || billingData.gstNumber || "";
  const partyState = (
    billingData.splitState ||
    billingData.state ||
    ""
  ).trim();
  return (
    gstNumber.startsWith("24") || partyState.toLowerCase() === "gujarat"
  );
}
